<template>
  <div>
    <div class="list-group array-box__items">
      <a
        class="list-group-item list-group-item-action cursor-pointer"
        href.prevent=""
        v-for="item of dataItems"
        v-bind:key="item"
      >
        <span>{{ item }}</span>
        <i @click="removeItem(item)" class="fa fa-trash text-danger float-right pt-1"></i>
        <i @click="editItem(item)" class="fa fa-pencil text-info float-right pr-4 pt-1"></i>
      </a>
      <div class="list-group-item">
        <input
          class="form-control"
          placeholder="Write something then press enter..."
          v-model="input"
          @keyup.enter.prevent="addItem()"
        />
      </div>
      <modal name="edit-modal" height="auto">
        <div class="p-4">
          <div class="h3 mb-3">Edit highligth </div>
          <form action="">
            <div class="list-group-item">
              <input
                  class="form-control"
                  placeholder="Write something"
                  v-model="editInput"
              />
            </div>


            <button class="btn btn-primary mt-3 w-100" type="button" @click="updateItem()" >
              Update
            </button>
          </form>
        </div>
      </modal>
    </div>

  </div>
</template>

<script>
export default {
  props:["initialData", "hasInitData", "items"],

  data() {
    return {
      input: "",
      editInput: "",
      itemToEdit:"",
      newItems:[],
      dataItems : this.items,
    };
  },

  // mounted() {
  //   if (this.initialData) {
  //     this.items = this.initialData;
  //     this.$emit("update", this.items);
  //   }
  // },

  watch: {
    hasInitData: {
      immediate: true,
      handler (val, oldVal) {
        if(val){
          this.items = this.initialData;
          this.$emit("update", this.dataItems);
        }

      }
    }
  },

  methods: {
    addItem() {
      this.dataItems.push(this.input);
      this.input = "";
      this.$emit("update", this.dataItems);
    },

    editItem(item){
      this.itemToEdit = item;
      this.editInput = item;
      this.$modal.show("edit-modal");
    },

    updateItem(){
      this.dataItems.forEach(item => {
        if(item === this.itemToEdit){
          this.newItems.push(this.editInput);
        }
        else{
          this.newItems.push(item);
        }
      })

      this.dataItems = this.newItems;
      this.newItems = [];
      this.itemToEdit = "";
      this.$emit("update", this.dataItems);

      this.$modal.hide("edit-modal");
    },

    removeItem(item) {
      if (confirm("Do you want to remove this item?")) {
        this.dataItems = this.items.filter((el) => el != item);
        this.$emit("update", this.dataItems);
      }
    },
  },
};
</script>

<style scoped>
.array-box__items a {
  padding: 7px 20px;
}
</style>